export default import.meta.ROLLDOWN_FILE_URL__xKZKRRIp5eLcuPn_tnqfg